import Menu from "./Menu.js";

export default Menu;